import React from "react";
import loadable from "@loadable/component";
import { useDispatch } from "react-redux";
import useTheme from "../../../../hooks/useTheme";


import { AppPrimaryButton } from "../../../UI/CustomButtons";
import { AppColumn, AppRow } from "../../../UI/Layouts";
import { SizedBox } from "../../../UI/Sizes";
import AppPrimaryTextfield from "../../../UI/TextInput";
import { t } from "i18next";
import { useResponsive } from "../../../UI/ResponsiveContext";
import { allPhoneOptions } from "../../../../utils/Constants/dails";
import PhoneInput from "../../../UI/PhoneInput";
import { validateEmail } from "../../../../utils/FieldValidation";
import { openModal } from "../../../../redux/Modals/ModalActions";
import { MODAL_BOTTOM_SHEET } from "../../../UI/Sheet/BottomSheet";

const TermsPage = loadable(() => import("../../../Terms/Terms"));

export function JobCandidateFormSection({
  formData,
  updateFormData,
  onSend,
  formErrors,
  isApplyingCandidate,
  candidateData,
  auth,
  compact = false,
}) {
  const dispatch = useDispatch();
  const { isMobile } = useResponsive();
  const theme = useTheme();
  const phoneOptions = Array.from(allPhoneOptions());

  const defaultPhoneCode = phoneOptions.find((option) => option.value === formData?.phoneCode);
  const isAuthenticated = !!(auth?.currentUser);
  const formSpacing = compact
    ? theme.spacing.compactElementPadding
    : theme.spacing.contentElementPadding;
  return (
    <div>
      <AppColumn>
        <AppColumn>
          <div
            style={{
              display: !isMobile && "flex",
              gap: theme.spacing.elementPadding,
            }}
          >
            <div style={{ flex: 1 }}>
              <AppPrimaryTextfield
                value={formData?.firstName ?? ""}
                autoComplete={'given-name'}
                prefixIcon={"user outline"}
                maxLine={1}
                hintText={t('candidatedetail.form.firstname')}
                onChange={(value) => updateFormData("firstName", value)}
                error={formErrors.firstName ?? ""}
                capitalizedText="word"
              />
            </div>
            <SizedBox height={formSpacing} />
            <div style={{ flex: 1 }}>
              <AppPrimaryTextfield
                value={formData?.lastName ?? ""}
                maxLine={1}
                hintText={t('candidatedetail.form.lastname')}
                autoComplete="family-name"
                prefixIcon={"user outline"}
                capitalizedText="word"
                onChange={(value) => updateFormData("lastName", value)}
                error={formErrors.lastName ?? ""}
              />
            </div>
          </div>
          <SizedBox height={formSpacing} />
        </AppColumn>
        <AppColumn>

          <div>
            <PhoneInput
              value={formData?.phone ?? ""}
              onChange={(value) => updateFormData("phone", value)}
              onCode={(value) => updateFormData("phoneCode", value)}
              defaultPhoneCode={defaultPhoneCode}
              error={formErrors.phone ?? ""}
            />
          </div>
          <SizedBox height={formSpacing} />
        </AppColumn>
        <AppColumn>
          <div>
            <AppPrimaryTextfield
              value={formData?.email ?? ""}
              prefixIcon={"mail outline"}
              autoComplete="email"
              disabled={isAuthenticated && validateEmail(formData?.email)}
              keyboardTextCapitalization={"none"}
              maxLine={1}
              hintText={t('candidatedetail.form.email')}
              onChange={(value) => updateFormData("email", value)}
              error={formErrors.email ?? ""}
            />
          </div>
        </AppColumn>
        <SizedBox
          height={
            compact
              ? theme.spacing.compactElementPadding
              : isMobile
                ? theme.spacing.contentElementPadding
                : theme.spacing.contentPadding
          }
        />

        <AppPrimaryButton
          onClick={() => {
            onSend();
          }}
          loading={isApplyingCandidate}
          size={"big"}
          content={t(candidateData ? 'candidatedetail.form.continue' : 'candidatedetail.form.im_interested')}
          style={{
            borderRadius: theme.radius.button,
          }}
        />

        <SizedBox height={theme.spacing.contentElementPadding} />
        <AppRow mainAxisAlignment={"center"}>
          <span style={{
            textAlign: "center",
          }}>
            {t('candidatedetail.terms_and_conditions')}{" "}
            <button
              type="button"
              onClick={() => {
                dispatch(openModal(MODAL_BOTTOM_SHEET, {
                  height: 90,
                  children: <TermsPage />,
                }));
              }}
              style={{
                padding: 0,
                border: 0,
                background: "transparent",
                color: theme.primaryColor,
                cursor: "pointer",
                font: "inherit",
                textDecoration: "underline",
              }}
            >
              {t('terms_and_conditions').toLowerCase()}
            </button>
          </span>
        </AppRow>
        <SizedBox
          height={
            compact
              ? theme.spacing.compactElementPadding
              : theme.spacing.elementPadding
          }
        />
      </AppColumn>
    </div>
  );
}
